module.exports = __webpack_public_path__ + "static/Thumb_NC1_Poster_comp-ffd7322f552e462f83b611945644268f.png";